// extracted by mini-css-extract-plugin
export var filterForm = "PostsModuleMixedLayout-module--filterForm--w6dno";
export var secondaryList = "PostsModuleMixedLayout-module--secondaryList--ELxhQ";